export default {
    'name': 'txt',
    'width': '88',
    'height': '76',
    'viewBox': '0 0 76 88',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 23.2409V80H71.1111V0H22.4796L0 23.2409Z\' fill=\'#006CFD\'/><rect width=\'44\' height=\'23\' transform=\'translate(32 49)\' fill=\'#C1E8FD\'/><path d=\'M44.5483 66V57.642H41.2863V56.2H49.6023V57.642H46.3123V66H44.5483ZM52.0007 66H50.1247L53.4427 60.932L50.1667 56.2H52.1407L54.5907 59.812L56.9567 56.2H58.8607L55.5567 61.058L58.9587 66H56.9987L54.4367 62.22L52.0007 66ZM62.6022 66V57.642H59.3402V56.2H67.6562V57.642H64.3662V66H62.6022Z\' fill=\'#0158CE\'/>'
}
